import { render, staticRenderFns } from "./Workshop.vue?vue&type=template&id=406152f6&scoped=true"
import script from "./Workshop.vue?vue&type=script&lang=ts"
export * from "./Workshop.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406152f6",
  null
  
)

export default component.exports